import _ from "lodash";
import { images } from "./images.app";

export const categoryIcons = {
    article: "book",
    webinar: "id card",
    video: "film",
    event: "calendar",
    document: "file",
    faq: "question circle",
    news: "newspaper",
    course: "graduation",
    feed: "users",
    search: "search",
    assessment: "question circle",
    gallery: "images",
    survey: "wpforms",
    game: "gamepad",
};

export const licenseMap = {
    free: {
        level: 0,
        planId: "freeplan",
        type: "FREE",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        visitorAnalytics: true,
    },
    essential: {
        level: 1,
        planId: "plan_MZnt6tia24nG92",
        type: "Essential",
        campaigns: 25,
        leads: false,
        customLogo: true,
        logicJumps: true,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: false,
        visitorAnalytics: true,
    },
    premium: {
        level: 2,
        planId: "plan_MZnt6tia24nG92",
        type: "Premium",
        campaigns: 100,
        leads: true,
        customLogo: true,
        logicJumps: false,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: false,
        visitorAnalytics: true
    },
    agency: {
        level: 3,
        planId: "plan_MZnt6tia24nG92",
        type: "AGENCY",
        campaigns: 9999999999,
        leads: true,
        customLogo: true,
        logicJumps: true,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: true,
        visitorAnalytics: true
    },
    essential_monthly: {
        level: 1,
        planId: "plan_MZnt6tia24nG92",
        type: "Essential",
        campaigns: 25,
        leads: false,
        customLogo: true,
        logicJumps: true,
        poweredBy: true,
        privateCampaigns: true,
        geoAnalytics: false,
        visitorAnalytics: true,
    },
    premium_monthly: {
        level: 2,
        planId: "plan_MZnt6tia24nG92",
        type: "Premium",
        campaigns: 100,
        leads: true,
        customLogo: true,
        logicJumps: false,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: false,
        visitorAnalytics: true
    },
    agency_monthly: {
        level: 3,
        planId: "plan_MZnt6tia24nG92",
        type: "AGENCY",
        campaigns: 9999999999,
        leads: true,
        customLogo: true,
        logicJumps: true,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: true,
        visitorAnalytics: true
    },
    perpbiz: {
        level: 2,
        planId: "plan_MZnt6tia24nG92",
        type: "BUSINESS",
        campaigns: 100,
        leads: true,
        customLogo: true,
        logicJumps: false,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: false,
        visitorAnalytics: false
    },

    quodeck: {
        level: 1,
        planId: "plan_MZnt6tia24nG92",
        type: "QUODECK",
        campaigns: 9999999999,
        leads: true,
        customLogo: true,
        logicJumps: true,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: true,
        visitorAnalytics: true
    },

    appsumo_tier_1: {
        level: 1,
        planId: "plan_MZnt6tia24nG92",
        type: "Essential",
        campaigns: 10,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: false,
        privateCampaigns: false,
        geoAnalytics: false,
        visitorAnalytics: true
    },
    appsumo_tier_2: {
        level: 1,
        planId: "",
        type: "Essential",
        campaigns: 25,
        leads: false,
        customLogo: true,
        logicJumps: false,
        poweredBy: false,
        privateCampaigns: false,
        geoAnalytics: false,
        visitorAnalytics: true
    },
    appsumo_tier_3: {
        level: 1,
        planId: "",
        type: "Premium",
        campaigns: 50,
        leads: true,
        customLogo: true,
        logicJumps: false,
        poweredBy: false,
        privateCampaigns: false,
        geoAnalytics: false,
        visitorAnalytics: true
    },
    appsumo_tier_4: {
        level: 1,
        planId: "",
        type: "Premium",
        campaigns: 75,
        leads: true,
        customLogo: true,
        logicJumps: false,
        poweredBy: false,
        privateCampaigns: true,
        geoAnalytics: true,
        visitorAnalytics: true
    },
    appsumo_tier_5: {
        level: 1,
        planId: "",
        type: "Premium",
        campaigns: 100,
        leads: true,
        customLogo: true,
        logicJumps: true,
        poweredBy: false,
        privateCampaigns: false,
        geoAnalytics: true,
        visitorAnalytics: true
    }
};

export const licenseLadder = {
    appSumo: {
        l1: {
            type: "Essential",
            license_name: "appsumo_tier_1",
            license_type: "Creator",
            subscription_plan: "AppSumoL1",
            end_date: new Date(7258118399000),
            maxUsers: 100,
            maxSpace: 2048,
            code: 1,
            features: [
                "Up to 10 active campaigns",
                "All interactive content formats",
                "Amplayfy attribution"
            ],
        },
        l2: {
            type: "Essential",
            license_name: "appsumo_tier_2",
            license_type: "Creator",
            subscription_plan: "AppSumoL2",
            end_date: new Date(7258118399000),
            maxUsers: 300,
            maxSpace: 2048,
            code: 2,
            features: [
                "Up to 25 active campaigns",
                "All interactive content formats",
                "Amplayfy attribution",
            ],
        },
        l3: {
            type: "Premium",
            license_name: "appsumo_tier_3",
            license_type: "Creator",
            subscription_plan: "AppSumoL3",
            end_date: new Date(7258118399000),
            maxUsers: 500,
            maxSpace: 5120,
            code: 3,
            features: [
                "Up to 50 active campaigns",
                "All interactive content formats",
                "Amplayfy attribution",
                "Unlimited lead collection"
            ],
        },
        l4: {
            type: "Premium",
            license_name: "appsumo_tier_4",
            license_type: "Creator",
            subscription_plan: "AppSumoL4",
            end_date: new Date(7258118399000),
            maxUsers: 700,
            maxSpace: 5120,
            code: 4,
            features: [
                "Up to 75 active campaigns",
                "All interactive content formats",
                "Amplayfy attribution",
                "Unlimited lead collection",
                "Advanced audience insights"
            ],
        },
        l5: {
            type: "Premium",
            license_name: "appsumo_tier_5",
            license_type: "Creator",
            subscription_plan: "AppSumoL5",
            end_date: new Date(7258118399000),
            maxUsers: 1000,
            maxSpace: 5120,
            code: 5,
            features: [
                "Up to 100 active campaigns",
                "All interactive content formats",
                "Customizable branding",
                "Unlimited lead collection",
                "Advanced audience insights",
            ],
        },
    },
}

export const appConfig = {
    // -----------------------------------------------------------------
    // #region App Configuration Section:
    // Please check with Code Maintainer before changing these
    // -----------------------------------------------------------------
    language: "en",
    recaptcha: "6LdsQ1QaAAAAAKPjt6fXhZ6ZO2ad-ENkzJ8iRfem",
    // recaptcha: "6LevA_0aAAAAAAtn9sn51hDZD6AUxXatyLtt9nfH", //Nuggets
    appName: {
        dashboard: "Amplayfy | Create Interactive Content",
        app: "Amplayfy Gallery",
    },
    appVersion: {
        current: "3.0.0",
        updateOn: "custom", //lts.stable.custom
        ios: "https://itunes.apple.com/us/app/QuoDeck/id1438603541",
        android:
            "https://play.google.com/store/apps/details?id=com.quodeckexpress",
    },
    apiUrls: {
        apiUrl: "https://www.amplayfy.com/",
        assetUrl: "https://www.amplayfy.com/",
        libraryUrl: "/api/v2/apiv2decks/getApiv2ImageShow/",
        assetLib: "assets",
    },
    multiBranded: false,
    singleCourseApp: false,
    registration: {
        creatorAllowed: true,
        allowed: false,
        subtle: false,
        defaults: {
            username: "guest",
            password: "P@ssw0rd",
        },
    },
    secretKey: "p20o20e13",
    clientApp: true,
    footer: {
        present: false,
        bgColor: "#454545",
        textColor: "#ffffff",
        text: " All Rights Reserved &copy; QuoDeck Technologies PLC",
    },
    // -----------------------------------------------------------------
    // #endregion
    // -----------------------------------------------------------------

    // -----------------------------------------------------------------
    // #region Customization Section:
    // Please inform the Client Manager if changing these
    // -----------------------------------------------------------------
    colors: {
        master: "#454545",
        masterText: "#ffffff",
        menuColor: "#454545",
        iconColor: "#ffffff",
        accents: {
            primary: "#ffb82f",
            primaryText: "#000000",
            secondary: "#ffc900",
            secondaryText: "#f5f5f5",
        },
    },
    ui: {
        logo: images.mainLogo,
        iconlogo: null,
        invertedButtons: false,
        roundedButtons: true,
    },
    promoImages: [
        {
            image: images.welcome,
            header: "Welcome to this great app",
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur pellentesque eros molestie tempus viverra. Ebros molestie tempus viverra.",
        },
    ],
    home: {
        banner: [],
        background: images.homePageBg,
        links: [
            {
                image: images.logoInverted,
                top: "10%",
                left: "20%",
                width: "60%",
                link: "/home",
                name: "Home",
            },
        ],
    },
    library: {
        banner: [],
        background: images.homePageBg,
    },
    learningCenter: {
        menuIcons: [
            {
                name: "Articles",
                icon: "book",
                children: [
                    {
                        name: "Articles",
                        icon: "book",
                        link: "/articles?category=article",
                    },
                    {
                        name: "FAQs",
                        icon: "question circle",
                        link: "/articles?category=faq",
                    },
                    {
                        name: "Documents",
                        icon: "file",
                        link: "/articles?category=document",
                    },
                ],
            },
            {
                name: "News and Stories",
                icon: "newspaper",
                link: "/articles?category=news",
            },
            {
                name: "Videos",
                icon: "film",
                link: "/articles?category=video",
            },
            {
                name: "Webinars",
                icon: "id card",
                link: "/articles?category=webinar",
            },
            {
                name: "Courses",
                icon: "graduation",
                link: "/articles?category=courses",
            },
            {
                name: "Community",
                icon: "users",
                link: "/feed",
            },
        ],
        menuNavigator: {
            article: "Category Tags",
            webinar: "Category Tags",
            event: "Category Tags",
            video: "Category Tags",
            document: "Category Tags",
            faq: "FAQ Tags",
            news: "Category Tags",
        },
        profileList: {
            notifications: true,
            reports: true,
            logout: true,
        },
        dashboard: {
            menu: [
                {
                    format: "list",
                    title: "RECENT ARTICLES",
                    icon: "book",
                    items: "articles",
                    category: "",
                    filter: [],
                    count: 5,
                    seemore: true,
                    seemoreLink: "/articles",
                },
                {
                    format: "card",
                    title: "ARTICLES IN HINDI",
                    icon: "language",
                    text: "A lot of our articles are available for you in Hindi. Why not check them out?",
                    button: {
                        text: "View All",
                        link: "/articles?tags=Hindi",
                    },
                },
            ],
            carousels: [
                {
                    title: "POPULAR ARTICLES",
                    items: "articles",
                    category: "",
                    filter: ["Popular"],
                    count: 10,
                    viewAll: "/articles?tags=Popular",
                },
                {
                    title: "UPCOMING WEBINARS",
                    items: "articles",
                    category: "event",
                    filter: [],
                    count: 10,
                    viewAll: "/articles?category=event",
                },
                {
                    title: "VIDEOS",
                    items: "articles",
                    category: "video",
                    filter: [],
                    count: 10,
                    viewAll: "/articles?category=video",
                },
                {
                    title: "COURSES",
                    items: "courses",
                    category: "",
                    filter: ["Public Library"],
                    count: 10,
                    viewAll: "/articles?category=courses",
                },
            ],
            listing: false,
        },
    },
    fonts: {
        custom: {
            families: [
                "icomoon",
                "Roboto",
                "Open Sans",
                "Oswald",
                "sans-serif",
            ],
            urls: _.map(
                ["icomoon", "Roboto", "OpenSans", "Oswald", "sans-serif"].slice(
                    0,
                    -1
                ),
                function (elm, index) {
                    return "assets/fonts/" + elm + ".css";
                }
            ),
        },
    },

    // -----------------------------------------------------------------
    // #endregion
    // -----------------------------------------------------------------

    // -----------------------------------------------------------------
    // #region User Details Parameters Section:
    // Copy as if from the server profile config file.
    // Please inform the Client Manager if changing these
    // -----------------------------------------------------------------
    detailParams: {
        ip: {
            faker: ["151.62.35.12"],
        },
        country: {
            faker: ["India", "Singapore", "France", "Germany"],
        },
        country_code: {
            faker: ["IN", "SG", "FR", "GE"],
        },
        region: {
            faker: [
                "Maharashtra",
                "Mumbai",
                "Delhi",
                "Chennai",
                "Bangalore",
                "London",
                "San Jose",
                "Dubai",
                "Adelaide",
            ],
        },
        city: {
            faker: ["Mumbai", "Delhi", "Paris", "London"],
        },
        browser: {
            faker: ["Chrome"],
        },
        version: {
            faker: ["85.0.4"],
        },
        os: {
            faker: ["Linux"],
        },
        platform: {
            faker: ["Linux"],
        },
        fulltrace: {
            faker: [""],
        },
    },

    // -----------------------------------------------------------------
    // #endregion
    // -----------------------------------------------------------------

    // -----------------------------------------------------------------
    // #region Routing Configuration Section:
    // Please check with Code Maintainer before changing these
    // -----------------------------------------------------------------
    auth: {
        routes: {
            afterSignIn: "/",
            afterSessionPath: "/",
            authenticatedRoot: "/",
            unauthenticatedRoot: "/login",
            login: "/drive/login",
            logout: "/logout",
            signup: "/register",
            forgotPassword: "/forgotPassword",
            helpDesk: "/helpDesk",
            backListSessionPath: [
                "/session/home",
                "/session",
                "/drive/login",
                "logout",
                "/home",
                "/undefined",
            ],
        },
        maxSessions: 100,
        stdauth: true,
        acceptTerms: true,
        omniauth: [
            {
                "url": "https://www.amplayfy.com/googlelogin?state=creator",
                "text": "google",
                "icon": "google"
            },
            // {
            //     "url": "https://www.amplayfy.com/facebooklogin?state=creator",
            //     "text": "facebook",
            //     "icon": "facebook"
            // }
        ],
    },
    endpoints: {
        //------------------------------------------------
        // Config Routes
        //------------------------------------------------
        setConfig: "/api/v2/config/upsert",
        getConfig: "/api/v2/config/fetch",
        //------------------------------------------------

        //------------------------------------------------
        // Authentication Routes
        //------------------------------------------------
        emailSignInPath: "/api/v2/auth/sign_in",
        emailForgotPasswordPath: "/api/v2/auth/reset_password",
        tokenSignInPath: "/api/v2/auth/sign_in",
        checkCaptchaPath: "/api/v2/utilities/recaptcha",
        signOutPath: "/api/v2/auth/sign_out",
        passwordUpdatePath: "/api/v2/auth/change_password",
        syncSessionsPath: "/api/v2/activity/:id/session_data",
        checkCouponPath: "/api/v2/coupons/:code/verify",
        assignCouponPath: "/api/v2/coupons/assign/:id",
        fetchUserCouponsPath: "/api/v2/coupons/:user_id/all_coupons",
        //------------------------------------------------

        //------------------------------------------------
        // User Management Routes
        //------------------------------------------------

        getUserListPath: "/api/v2/users/list/basic",
        getDeactivatedUsersPath: "/api/v2/users/list/deactivated",
        getUserQueryPath: "/api/v2/users/list/query",
        getUserSearchPath: "/api/v2/users/list/search",
        getUserDetailsPath: "/api/v2/users/:id/show",
        getUserAncestorsPath: "/api/v2/users/:id/hierarchy/ancestors",
        getUserChildrenPath: "/api/v2/users/:id/hierarchy/children",
        getUserDescendantsPath: "/api/v2/users/:id/hierarchy/descendants",

        createUserPath: "/api/v2/users/create",
        createAndEnrollUserPath: "/api/v2/users/createnroll",
        updateUserDetailsPath: "/api/v2/users/:id/update/details",
        updateUserManagerPath: "/api/v2/users/:id/update/manager",
        updateUserLicensePath: "/api/v2/users/:id/update/license",
        updateUserProfilePath: "/api/v2/users/:id/update/profile",
        activateUserPath: "/api/v2/users/:id/activate",
        deactivateUserPath: "/api/v2/users/:id/deactivate",
        deleteUserPath: "/api/v2/users/:id/delete",

        //------------------------------------------------

        //------------------------------------------------
        // Library Management Routes
        //------------------------------------------------
        creatorLibraryPath: "/api/v2/categories/list",
        learnerLibraryPath: "/api/v2/library",
        //------------------------------------------------

        //------------------------------------------------
        // Telemetry Routes
        //------------------------------------------------
        sendTrackerPath: "/api/v2/activity/tracker",
        fetchTrackerPath: "/api/v2/activity/:user_id/log",
        //------------------------------------------------

        //------------------------------------------------
        // Content Creation Routes
        //------------------------------------------------
        builderPaths: {
            createCategoryPath: "/api/v2/categories/create",
            updateCategoryPath: "/api/v2/categories/:id/update",
            deleteCategoryPath: "/api/v2/categories/:id/delete",

            addCoursePath: "/api/v2/courses/create",
            getCoursesPath: "/api/v2/courses/list",
            updateCoursePath: "/api/v2/courses/:id/update",
            deleteCoursePath: "/api/v2/courses/:id/delete",

            addTopicPath: "/api/v2/courses/:id/topics/create",
            updateTopicPath: "/api/v2/courses/:course_id/topics/:id/update",
            deleteTopicPath: "/api/v2/courses/:course_id/topics/:id/delete",
            reorderTopicsPath:
                "/api/v2/courses/:course_id/topics/:id/move/:direction",

            createDeckPath: "/api/v2/decks/create",
            updateDeckPath: "/api/v2/decks/:id/update",
            deleteDeckPath: "/api/v2/decks/:id/delete",
            reorderDecksPath: "/api/v2/decks/:id/move/:direction",
        },
        contentPaths: {
            getCoursePath: "/api/v2/courses/:id/show",
            getDeckPath: "/api/v2/decks/:id/show",
            getCourseLeaderboardPath:
                "/api/v2/courses/:id/leaderboards/finalexam", //Add this
        },
        //------------------------------------------------

        //------------------------------------------------
        // Course Enrolment Routes
        //------------------------------------------------
        learnerManagerPaths: {
            getLearnersPath: "/api/v2/courses/:id/learners/list",
            addLearnerPath: "/api/v2/courses/:course_id/learners/:id/add",
            deleteLearnerPath: "/api/v2/courses/:course_id/learners/:id/remove",
            enrolAllPath: "/api/v2/courses/:id/learners/add_all",

            modifyLearnerPath: "/api/v2/courses/:course_id/modify_learner/:id",
            contactLearnerPath:
                "/api/v2/courses/:course_id/learner/:id/contact",
            triggerNotificationPath: "api/v2/users/:id/notifications/create",
            fetchLearnerNotifications: "api/v2/users/:id/notifications/fetch",
            getCohortTagsPath: "/api/v2/tag_lists",
        },
        enrollmentRulePaths: {
            addEnrollmentRule: "/api/v2/courses/:id/rules/add",
            removeEnrollmentRule: "/api/v2/courses/:course_id/rules/:id/remove",
            runEnrollmentRule: "/api/v2/courses/:course_id/rules/:id/run",
        },
        //------------------------------------------------

        //------------------------------------------------
        // Admin Panels Routes
        //------------------------------------------------
        adminDataPaths: {
            getAllCoursesPath: "/api/v2/courses/list",

            getLearnerProfilePath: "/api/v2/analytics/:id/profile",
            getLearnerActivityPath: "/api/v2/analytics/:id/participation",

            getLearnerCoursesPath: "/api/v2/users/:id/show/courses",
            getLearnerProgressPath: "/api/v2/analytics/:id/progress",
            getLearnerCourseProgressPath:
                "/api/v2/analytics/:id/:course_id/progress",

            getLearnerCompletedCoursesPath:
                "/api/v2/analytics/:id/completed/courses",
            getLearnerPerformancePath: "/api/v2/analytics/:id/performance",
            getLearnerCoursePerformancePath:
                "/api/v2/analytics/:id/:course_id/performance",

            getTeamSummaryPath: "/api/v2/analytics/:id/team/summary",
            getTeamCoursePerformancePath:
                "/api/v2/analytics/:id/team/:course_id/performance",

            getTeamCoursesPath: "/api/v2/analytics/:id/team/courses",
            getOwnedCoursesPath: "/api/v2/analytics/:id/owned/courses",

            getCourseLearnersPath:
                "/api/v2/analytics/:id/:course_id/learners/:scope",
            getTopicLearnersPath:
                "/api/v2/analytics/:id/:course_id/:topic_id/learners/:scope",
            getDeckLearnersPath:
                "/api/v2/analytics/:id/:course_id/:deck_id/learners/:scope",

            getSurveyStatusPath:
                "/api/v2/analytics/questions/:id/responses/:groupBy",

            // changeOwnerPath: "/api/v2/courses/:course_id/change_owner/:id",
            // getLearnerTopicsPath:
            //     "/api/v2/courses/:course_id/learner/:id/topic_status",
            // getLearnerDecksPath:
            //     "/api/v2/courses/:course_id/learner/:id/deck_status",
            // getAssessmentStatusPath: "/api/v2/assessments/:id/status",

            getCompetencyMapPath: "/api/v2/analytics/:id/competency_map",
            getReportPath: "/api/v2/analytics/reports/:report", //Add this
        },
        //------------------------------------------------

        //------------------------------------------------
        // Social Feed Routes
        //------------------------------------------------
        feedPath: "/api/v2/social/feed",
        createPostPath: "/api/v2/social/posts/create",
        deletePostPath: "/api/v2/social/posts/:id/delete",
        createPostCommentPath: "api/v2/social/posts/:id/comments/create",
        deletePostCommentPath:
            "api/v2/social/posts/:id/comments/:comment_id/delete",
        likePostPath: "api/v2/social/posts/:id/like",

        //------------------------------------------------

        //------------------------------------------------
        // Adverts Routes
        //------------------------------------------------
        getAdvertsPath: "/api/v2/banners/list",
        getPublishedAdvertsPath: "/api/v2/banners/published_list",
        createAdvertPath: "/api/v2/banners/create",
        editAdvertPath: "/api/v2/banners/:id/update",
        showAdvertPath: "/api/v2/banners/:id/show",
        deleteAdvertPath: "/api/v2/banners/:id/delete",

        //------------------------------------------------

        //------------------------------------------------
        // Blog Routes
        //------------------------------------------------
        blogPath: "/api/v2/articles/list",
        blogTemplatesPath: "/api/v2/articles/get_templates",
        blogPublishedPath: "/api/v2/articles/published_list",
        leadsPath: "/api/v2/activity/get_leads",
        tagsPath: "/api/v2/tags/list",
        createTagsPath: "/api/v2/tags/bulk_create",
        editTagPath: "/api/v2/tags/:id/update",
        deleteTagPath: "/api/v2/tags/:id/delete",
        createArticlePath: "/api/v2/articles/create",
        getArticlePath: "/api/v2/articles/:id/show",
        getDeepArticlePath: "/api/v2/urls/create/:id",
        updateArticlePath: "/api/v2/articles/:id/update",
        deleteArticlePath: "/api/v2/articles/:id/delete",
        toggleLikePath: "api/v2/articles/:id/like",
        createArticleCommentPath: "api/v2/articles/:id/comments/create",
        deleteArticleCommentPath:
            "api/v2/articles/:id/comments/:comment_id/delete",

        //------------------------------------------------

        uploadQDFPath: "/api/v2/apiv2decks/",
        editProfilePath: "/api/v2/profiles/:id",
        profilePhotoPath: "/api/v2/profiles/:id",
        getClientConfigPath: "/api/v2/courses/:id/client",
        mailCertificatePath: "/api/v2/certdecks/certificate_downloads/send",
        getStatsPath: "/api/v2/stats",
        updateConfigPath: "/api/v2/clients/:id",
        scormifyPath: "/api/v2/utilities/scormify/:id",
        evalFormulaPath: "/api/v2/utilities/eval_formula",
        createOrderPath: "/api/v2/utilities/payments/create_order/:id",
        verifyOrderPath: "/api/v2/utilities/payments/verify_order",
        createSubscriptionPath:
            "/api/v2/utilities/payments/create_subscription/:id",
        verifySubscriptionPath:
            "/api/v2/utilities/payments/verify_subscription",
        getInvoicesPath: "/api/v2/utilities/payments/fetch_invoices/:id",

        ticket: "/en/tickets/mobile",
        getLicensePath: "/api/v2/licenses/:id",
    },

    unauthenticatedPaths: [
        "createUserPath",
        "checkCaptchaPath",
        "emailSignInPath",
        "tokenSignInPath",
        "emailForgotPasswordPath",
        "wsFedLogin",
        "omniauthGoogle",
        "omniauthfacebook",
        "ticket",
        "emailRegistrationPath",
        "emailSignInPathBypass",
        "getDeepArticlePath",
        "getConfig",
    ],
    // -----------------------------------------------------------------
    // #endregion
    // -----------------------------------------------------------------
};
